import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { Config } from '../../config/config';
@Injectable({
  providedIn: 'root'
})
export class CtbCcService {

  dataUrl = Config.URL_BASE;

  constructor(
    private http: HttpClient
  ) { }

  catalogo(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  post(dto: Ctbcc): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/ctbcc/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  put(dto: Ctbcc): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  
  getAutocompletado(codigo:string, titulo:string,gral_emp_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/get/autocompletado/' + codigo + '/' + titulo + '/' + gral_emp_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getConcepto(id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getReporteBalanzaComprobacionCc(_mes: number,_anio: number,_ctb_cc_id: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/get/balanza/' + _mes + '/' + _anio + '/' + _ctb_cc_id + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  } 
  //{_mes_ini}/{_mes_fin}/{_anio}/{_ctb_cc_id}/{_empresa_id}
  getReporteEstadoResultadosCc(_mes_ini: number,_mes_fin: number,_anio: number,_ctb_cc_id: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/get/estadoresultados/' + _mes_ini + '/' + _mes_fin + '/' + _anio + '/' + _ctb_cc_id + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  } 
  //{_mes_ini}/{_mes_fin}/{_anio}/{_ctb_cc_id}/{_empresa_id}
  getReporteGastosSucursal(_mes_ini: number,_mes_fin: number,_anio: number,_gral_suc_id: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/get/gastossucursal/' + _mes_ini + '/' + _mes_fin + '/' + _anio + '/' + _gral_suc_id + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  } 
  getRepGasSucXlsx(_mes_ini: number,_mes_fin: number,_anio: number,_gral_suc_id: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/rep_gas_suc/xlsx/' + _mes_ini + '/' + _mes_fin + '/' + _anio + '/' + _gral_suc_id + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, {}, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepGasSucPdf(_mes_ini: number,_mes_fin: number,_anio: number,_gral_suc_id: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/rep_gas_suc/pdf/' + _mes_ini + '/' + _mes_fin + '/' + _anio + '/' + _gral_suc_id + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, {}, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepEstResXlsx(_mes_ini: number,_mes_fin: number,_anio: number,_ctb_cc_id: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/rep_est_res/xlsx/' + _mes_ini + '/' + _mes_fin + '/' + _anio + '/' + _ctb_cc_id + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, {}, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepEstResPdf(_mes_ini: number,_mes_fin: number,_anio: number,_ctb_cc_id: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/rep_est_res/pdf/' + _mes_ini + '/' + _mes_fin + '/' + _anio + '/' + _ctb_cc_id + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, {}, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  selectByMesAnioEmp(_mes: number,_anio: number,_empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/get/select/' + _mes + '/' + _anio + '/' + _empresa_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


  getRepBalCompXlsx(_mes: number, _anio: number,_ctb_cc_id: number, _empresa_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcc/rep_bal_comp/xlsx/' + _mes + '/' + _anio + '/' + _ctb_cc_id + '/' + _empresa_id + '';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, {}, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}

export class Ctbcc {
  id: number;
  folio: String = '';
  codigo: String = '';
  titulo: String = '';
  momento_crea: String = '';
  gral_emp_id: number;
  momento_actualiza: String = '';
  momento_baja: String = '';
  gralUsrCreaId: number;
  gralUsrActualizaId: number;
  gralUsrBajaId: number;
}

export class PageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
  page1?: boolean | undefined = false;
}
